import { INIT_FLIP_STATE } from '../ducks/flipState'

// route 할 때마다, 계속 바뀜 (A -> B -> C -> D -> E -> A)
export enum StateKey {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
}

export type FlipState<T> = { [x in StateKey]: T }

export const initialStateKey = StateKey.A

// route 시작 시 curState 설정
// predictable 한 global 변수 관리를 위해 onLocationChange - clientEntry 외 다른 곳에서 설정하지 말아주세요
// 설정할 필요가 있을 때 최효석(hyoseok.choi@navercorp.com) 에게 문의 부탁드립니다.

export const getNextState = (curState: StateKey) => {
  switch (curState) {
    case StateKey.A:
      return StateKey.B
    case StateKey.B:
      return StateKey.C
    case StateKey.C:
      return StateKey.D
    case StateKey.D:
      return StateKey.E
    case StateKey.E:
      return StateKey.A
  }
}

// initial render 시, redux state 의 prevState key 에 해당하는 object 는 undefined 입니다.
// flipState.ts 에서 정의된 함수 외에는 사용하지 말아주세요.
// 사용할 필요가 있을 때 최효석(hyoseok.choi@navercorp.com) 에게 문의 부탁드립니다.
export const getPrevState = (curState: StateKey) => {
  switch (curState) {
    case StateKey.A:
      return StateKey.E
    case StateKey.B:
      return StateKey.A
    case StateKey.C:
      return StateKey.B
    case StateKey.D:
      return StateKey.C
    case StateKey.E:
      return StateKey.D
  }
}

export const flipReducer = reducer => (state, action) => {
  if (!state) {
    return {
      [initialStateKey]: reducer(state, action),
    }
  }
  if (action.type === INIT_FLIP_STATE) {
    return {
      ...state,
      [action.curState]: state[getPrevState(action.curState)],
    }
  }
  if (action.curState) {
    const curStateKey = action.curState
    const curState = reducer(state && state[curStateKey], action)
    return {
      ...state,
      [curStateKey]: curState,
    }
  }
  return state
}
